<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container" v-if="!loading">
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div
            class="flex-card light-bordered light-raised has-margin-top-30"
            style="overflow: auto"
          >
            <div class="card-body">
              <div class="has-text-centered has-margin-bottom-30">
                <h2 class="title">Manage Dependants</h2>
                <p>
                  <strong>NOTE:</strong> You can only add dependants 18 years
                  and younger. If they're older they need their own unique email
                  address.
                </p>
              </div>
              <div>
                <table class="table is-fullwidth is-hoverable is-striped">
                  <thead>
                    <th>Name</th>
                    <th>Gender</th>
                    <th>Date of Birth</th>
                    <th>Gym Name</th>
                    <th>Actions</th>
                  </thead>
                  <tbody>
                    <tr v-for="dependant in dependants" :key="dependant._id">
                      <td>{{ dependant.firstname }} {{ dependant.surname }}</td>
                      <td>{{ dependant.gender }}</td>
                      <td>{{ dependant.dob | date }}</td>
                      <td>{{ dependant.gymname }}</td>
                      <td>
                        <a href="" @click="editDependant(dependant)">Edit</a
                        >&nbsp;&nbsp;<a
                          href=""
                          @click.prevent.stop="removeDependant(dependant)"
                          >Remove</a
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="has-text-centered has-margin-top-15">
                  <p
                    class="has-margin-bottom-30"
                    v-if="dependants.length === 0"
                  >
                    No dependants yet.
                  </p>
                  <button class="button is-primary" @click="addDependant">
                    Add Dependant
                  </button>
                </div>
              </div>
              <ConfirmModal
                ref="deleteModal"
                title="Confirm Delete?"
                message="Are you sure you want to delete the dependant?"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConfirmModal from "@/components/ConfirmModal";
import filters from "@/filters";
import DependantApi from "@/api/dependant";
export default {
  components: {
    ConfirmModal,
  },
  mixins: [filters],
  data() {
    return {
      loading: true,
      currentUser: {},
    };
  },
  computed: {
    ...mapGetters(["user", "dependants"]),
  },
  async created() {
    await this.getDependants();
    this.loading = false;
  },
  methods: {
    ...mapActions(["getDependants"]),
    addDependant() {
      this.$router.push({ name: "AddDependant" });
    },
    editDependant(dependant) {
      this.$router.push({
        name: "EditDependant",
        params: { id: dependant._id },
      });
    },
    removeDependant(dependant) {
      let dependantId = dependant._id;
      this.$refs.deleteModal
        .show()
        .then(() => {
          return DependantApi.remove(dependantId);
        })
        .then(this.getDependants)
        .then(() => {
          this.$buefy.toast.open({
            message: "Removed dependant successfully!",
            position: "is-top",
            type: "is-success",
          });
        });
    },
  },
};
</script>
